export enum VisitSource {
    Er = 1,
    Opd = 2,
    ConsultationRequest = 3,
}
